import { I18n } from 'i18n-js'
import * as RNLocalize from 'react-native-localize'

import i18nEnglishTranslations from './i18nEnglishTranslations'
import i18nSpanishTranslations from './i18nSpanishTranslations'
import i18nJapaneseTranslations from './i18nJapaneseTranslations'
import i18nFrenchTranslations from './i18nFrenchTranslations'
import i18nGermanTranslations from './i18nGermanTranslations'
import i18nPortuguesePTTranslations from './i18nPortuguesePTTranslations'
import i18nPortugueseBRTranslations from './i18nPortugueseBRTranslations'
import i18nIndonesianTranslations from './i18nIndonesianTranslations'
import i18nItalianTranslations from './i18nItalianTranslations'
import i18nRussianTranslations from './i18nRussianTranslations'
import i18nKoreanTranslations from './i18nKoreanTranslations'
import i18nDutchTranslations from './i18nDutchTranslations'
import i18nUkrainianTranslations from './i18nUkrainianTranslations'
import i18nTurkishTranslations from './i18nTurkishTranslations'

const locales = RNLocalize.getLocales()

const supportedLanguages = [
  'en',
  'es',
  'fr',
  'de',
  'ja',
  'pt-PT',
  'pt-BR',
  'id',
  'it',
  'ru',
  'ko',
  'nl',
  'uk',
  'tr'
]

const i18n = new I18n({
  en: i18nEnglishTranslations,
  es: i18nSpanishTranslations,
  fr: i18nFrenchTranslations,
  de: i18nGermanTranslations,
  ja: i18nJapaneseTranslations,
  'pt-PT': i18nPortuguesePTTranslations,
  'pt-BR': i18nPortugueseBRTranslations,
  id: i18nIndonesianTranslations,
  it: i18nItalianTranslations,
  ru: i18nRussianTranslations,
  ko: i18nKoreanTranslations,
  nl: i18nDutchTranslations,
  uk: i18nUkrainianTranslations,
  tr: i18nTurkishTranslations
})

i18n.defaultLocale = 'en'

if (Array.isArray(locales)) {
  const deviceLocale =
    window.localStorage.getItem('deviceLocale') || locales[0].languageTag
  let selectedLocale = 'en'

  // First try exact match (e.g., "pt-BR")
  if (supportedLanguages.includes(deviceLocale)) {
    selectedLocale = deviceLocale
  } else {
    // If no exact match, try matching just the language part (e.g., "es" from "es-CO")
    const languageCode = deviceLocale.split('-')[0]
    if (supportedLanguages.includes(languageCode)) {
      selectedLocale = languageCode
    }
  }

  i18n.locale = selectedLocale
}

i18n.enableFallback = true

i18n.currentLocale = function () {
  return this.locale
}

export default i18n
